import React from "react";

export const AppearanceTextarea = ({
    register,
    value,
    field,
    keyName,
    children = [],
    placeholder = "",
}) => {
    return (
        <div>
            <textarea
                className="form-control"
                defaultValue={value}
                placeholder={placeholder}
                ref={register}
                rows={5}
                name={field.appearanceName(keyName)}
            />
        </div>
    );
};
